import React, { useState } from 'react'
import { TextField, Button } from "@mui/material";
import blogServices from '../services/blogs'

const BlogForm = ({ blogs, setBlogs, user, handleLogout }) => {
  const [ title, setTitle ] = useState('')
  const [ author, setAuthor ] = useState('')
  const [ url, setUrl ] = useState('')
  const [ likes, setLikes ] = useState(0)
  const [ add, setAdd ] = useState(false)

  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function(txt){
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  const handleNewBlog = async (e) => {
    e.preventDefault()
    const newBlog = {
        title: toTitleCase (title),
        author: toTitleCase (author),
        url,
        likes
    }

    try {
        const returnedBlog = await blogServices.createBlog(newBlog)
        const blogPoster = {
            username: user.username,
            name: user.name
        }
        setBlogs(blogs.concat({ ...returnedBlog, user: blogPoster }))
        setTitle('')
        setAuthor('')
        setUrl('')
        setLikes(0)
        setAdd(false)
    } catch (exception) {
    if (exception.response.status === 403) {
      window.alert("Session expired")
      handleLogout()
    }
    console.log(`exception: ${exception}`)
    }
  }

  return (
    <>
      <div className="column">
        <p>Add blog and we'll create a summary</p>
        <Button onClick={() => setAdd(!add)}>Add blog</Button>
        {add ?
            <form onSubmit={handleNewBlog} className="form">
                <TextField
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                name="Blog Title"
                placeholder="title"
                InputProps={{
                    className: "input",
                }}
                />
                <TextField
                type="text"
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
                name="Blog Author"
                placeholder="author"
                InputProps={{
                    className: "input",
                }}
                />
                <TextField
                type="text"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                name="Blog URL"
                placeholder="url"
                InputProps={{
                    className: "input",
                }}
                />
                <TextField
                type="text"
                value={likes || ''}
                onChange={(e) => setLikes(e.target.value)}
                name="Blog Likes"
                placeholder="likes"
                InputProps={{
                    className: "input",
                }}
                />
                <Button type="submit">Add</Button>
            </form> :
            <></>}
      </div>
    </>
  )
}

export default BlogForm